import LegalPage from "@/components/LegalPage";
import { CONTACT_EMAIL } from "@/lib/config";

export default function Privacy() {
    return (
        <LegalPage
            testId="privacy-page"
            eyebrow="Legal"
            title="Privacy Policy"
            updated="June 2026"
            seoTitle="Privacy Policy · Abhijit J K"
            seoDescription="How Abhijit J K (Ragi Media) collects, uses, and protects your personal information when you use this website and book a consultation."
            intro="This Privacy Policy explains how Abhijit J K (Founder, Ragi Media), Bengaluru, India, collects, uses, and protects your personal information when you use this website or book a consultation."
            sections={[
                {
                    heading: "Information We Collect",
                    list: [
                        "Contact details: name, email address, and phone/WhatsApp number.",
                        "Business details you choose to share for the consultation.",
                        "Booking details such as your selected date and time.",
                        "Payment is processed by Razorpay; we receive only confirmation status, not your full card or bank details.",
                    ],
                },
                {
                    heading: "How We Use Your Information",
                    list: [
                        "To confirm and deliver your consultation.",
                        "To communicate booking confirmations, meeting links, and reminders.",
                        "To respond to your enquiries and provide support.",
                        "To improve our services and website experience.",
                    ],
                },
                {
                    heading: "Third-Party Services",
                    body: [
                        "We use trusted third-party providers to operate our services:",
                    ],
                    list: [
                        "Razorpay — secure payment processing.",
                        "Calendly — scheduling and slot booking.",
                        "Google Meet — hosting the online consultation.",
                        "These providers process data under their own privacy policies.",
                    ],
                },
                {
                    heading: "Cookies",
                    body: "This website and embedded tools (such as the scheduling widget) may use cookies to enable core functionality and improve your experience. You can control cookies through your browser settings.",
                },
                {
                    heading: "Data Security",
                    body: "We take reasonable measures to protect your personal information. However, no method of transmission over the internet is completely secure, and we cannot guarantee absolute security.",
                },
                {
                    heading: "Data Retention",
                    body: "We retain your information only as long as necessary to deliver our services and comply with legal obligations.",
                },
                {
                    heading: "Your Rights",
                    body: `You may request access to, correction of, or deletion of your personal information by contacting us at ${CONTACT_EMAIL}.`,
                },
                {
                    heading: "Contact",
                    body: `For any privacy-related questions, contact us at ${CONTACT_EMAIL}.`,
                },
            ]}
        />
    );
}
